import { useLingui } from '@lingui/react'
import { useEffect } from 'react'
import { DataPlayer } from 'player'
import { Task } from '../../../../types'
import { useStorePlayer } from '../store'
import { useDataMetadata } from './use-data-metadata'

interface UseDataProps {
  task: Task
  typeOp: 'mastering' | 'denoiser'
}

export const useData = ({ task, typeOp }: UseDataProps): DataPlayer => {
  const { i18n } = useLingui()
  const { data, setData } = useStorePlayer()

  useDataMetadata({
    task
  })

  const filename = task.file?.name

  useEffect(() => {
    setData({
      filename
    })
  }, [filename, typeOp, i18n, setData])

  return data
}
